var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopTheaterModeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.5H5C3.9 3.5 3 4.4 3 5.5V17.5C3 18.6 3.9 19.5 5 19.5H8V21.5H16V19.5H19C20.1 19.5 20.99 18.6 20.99 17.5L21 5.5C21 4.4 20.1 3.5 19 3.5ZM19 17.5H5V5.5H19V17.5Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5L6 11.5L11 16.5V6.5Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5L18 11.5L13 6.5L13 16.5Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopTheaterModeIcon);
export default __webpack_public_path__ + "static/media/stop_theater_mode_icon.fd5f61f5.svg";
export { ForwardRef as ReactComponent };